import React, { useMemo } from "react";
import {
  type MRT_ColumnDef,
} from "material-react-table";
import { Box, useTheme } from "@mui/material";
import { scoringQuestionData } from "../../../../util/admin/dumyData";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";

type scoringQuestion = {
    question: string;
};
const scoringQuestionColumns: MRT_ColumnDef<scoringQuestion>[] = [
    {header: "QUESTION",accessorKey: "question"}
];
const ScoringQuestionTable = () => {
  const columns = useMemo<MRT_ColumnDef<scoringQuestion>[]>(
    () => scoringQuestionColumns,
    []
  );
  const theme = useTheme()
  const data = useMemo(() => scoringQuestionData, []);

  return (
    <Box>
       <AdminGlobalTable
              columns={columns}
              data={data}
              config={{
                enableGlobalFilter: false,
                enableDensityToggle: false,
                enablePagination: false,
                muiSelectCheckboxProps: { color: "secondary" },
                muiTableContainerProps: {
                  sx: {
                    maxHeight: "calc(100vh - 590px)",
                    minHeight: "calc(100vh - 590px)",
                  },
                },
                muiTableBodyRowProps: () => ({
                  hover: false,
                  sx: {
                    backgroundColor: "transparent",
                    ":hover": { backgroundColor: theme.custom.hoverOptionColor },
                  },
                }),
                 renderTopToolbar: () => {
                  return <></>;
                },
              
              }}
            />
    </Box>
  );
};

export default ScoringQuestionTable;
